(function () {
  const gridSelector = '[data-recipient-grid]';
  const instances = new Map();

  class RecipientGrid {
    constructor(element) {
      this.element = element;
      this.cards = Array.from(this.element.querySelectorAll('.recipient-grid__card'));

      if (!this.cards.length) return;

      this.onResize = this.debounce(() => this.equalizeHeights(), 120);
      this.equalizeHeights();
      window.addEventListener('resize', this.onResize);
    }

    disconnect() {
      if (this.onResize) {
        window.removeEventListener('resize', this.onResize);
      }
    }

    equalizeHeights() {
      this.cards.forEach((card) => {
        card.style.minHeight = '';
      });

      let tallest = 0;
      this.cards.forEach((card) => {
        tallest = Math.max(tallest, card.offsetHeight);
      });

      this.cards.forEach((card) => {
        card.style.minHeight = `${tallest}px`;
      });
    }

    debounce(callback, wait) {
      let timeout;

      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => callback.apply(this, args), wait);
      };
    }
  }

  function getTargets(root) {
    const targets = [];

    if (root instanceof Element && root.matches(gridSelector)) {
      targets.push(root);
    }

    if (root.querySelectorAll) {
      targets.push(...root.querySelectorAll(gridSelector));
    }

    return targets;
  }

  function init(root) {
    getTargets(root).forEach((element) => {
      if (instances.has(element)) return;
      instances.set(element, new RecipientGrid(element));
    });
  }

  function destroy(root) {
    getTargets(root).forEach((element) => {
      const instance = instances.get(element);
      if (!instance) return;

      instance.disconnect();
      instances.delete(element);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    destroy(event.target);
  });
})();
